import React from 'react';

const ArrowUp = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 5" {...props}>
    <path fillRule="evenodd" d="M0 5l5-5 5 5z" />
  </svg>
);

export default ArrowUp;
